/**
 * True when a report generation answer is an accepted background job rather
 * than an already generated report.
 *
 * @param response the parsed body of a report generation request
 * @returns whether the body carries a job id
 */
export var isReportJobStarted = function (response) {
    return typeof response === "object" &&
        response !== null &&
        typeof response.jobId === "string";
};
/** True for the statuses in which a job is still being generated. */
export var isReportJobActive = function (status) {
    return status === "PENDING" || status === "RUNNING";
};
